import { Component, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Dialog } from '@capacitor/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppCommonModule } from 'src/app/common.module';
import { ContractorsService } from 'src/app/services/contractors.service';
import { DataBlockComponent } from 'src/app/ui/data-block/data-block.component';

@Component({
  selector: 'app-contractor-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    FormsModule,
    DataBlockComponent,
  ],
})
export class ContractorIntroComponent {
  private contractorsService = inject(ContractorsService);
  private translate = inject(TranslateService);

  contractor = this.contractorsService.contractorS();
  saved = output();
  readonly companyFields = [
    { field: 'name', labelKey: 'signup.businessName' },
    { field: 'businessId', labelKey: 'signup.businessId' },
    { field: 'email', labelKey: 'item.email' },
    { field: 'www', labelKey: 'signup.www' },
    { field: 'turnoverClass', labelKey: 'intro.turnoverClass' },
    { field: 'personnel', labelKey: 'intro.personnel' },
    { field: 'clientsInfo', labelKey: 'intro.clientsInfo' },
  ];

  addService() {
    Dialog.prompt({
      title: this.translate.instant('kanban.newItem'),
      message: this.translate.instant('item.name'),
    }).then((dialogValue) => {
      if (dialogValue.value) {
        if (this.contractor.services == null) {
          this.contractor.services = [];
        }
        this.contractor.services.push(dialogValue.value);
        this.persist();
      }
    });
  }

  editField(field: string, labelKey: string) {
    Dialog.prompt({
      message: this.translate.instant(labelKey),
      inputText: this.contractor[field] ?? '',
    }).then((dialogValue) => {
      if (dialogValue.value != null) {
        this.contractor[field] = dialogValue.value;
        this.persist();
      }
    });
  }

  save() {
    this.persist();
  }

  getFieldValue(field: string) {
    return this.contractor[field] || '-';
  }

  private persist() {
    this.contractorsService.update(this.contractor).then(() => this.saved.emit());
  }
}
